<app-size-detector>
  <app-spinner></app-spinner>
  <div class="app-wrapper"
        [ngClass]="{ 'scrolled': scrolled, 'nav-up': navUp }">
    <router-outlet></router-outlet>
  </div>
</app-size-detector>
